import React from 'react';
import { DropDownList } from '../dropDownList';

export const DropdownWrapper = ({
  register, name, title, subtitle, options, error,
  disabled, onChange, renderSelections, responsiveClassName,
  defaultValue,
}) => {
  return (
    <div className={responsiveClassName}>
      <div>
        <DropDownList
          showLabel
          {...(register ? register(name) : {})}
          id={name}
          name={name}
          label={title}
          subtitle={subtitle}
          options={options}
          onChange={onChange}
          disabled={disabled}
          className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
          defaultValue={defaultValue}
        />
      </div>
      {error && (
      <p className="mt-2 text-sm text-red-600" id={`${name}-error`}>
        {error.message}
      </p>
      )}
      {!!renderSelections && renderSelections()}
    </div>
  );
};
